import {Box, Paper} from "@mui/material";
import Grid from '@mui/material/Grid';
import {yellow, blueGrey} from '@mui/material/colors';

import TimeslotDetailsCard from "./TimeslotDetailsCard";
import SlidingTimeslotPanel from "./sliding/SlidingTimeslotPanel";
import {buildMostUpcomingShiftWhichRequiresPerformerCheckIn} from "../../helpers/SessionHelper";
import PerformerSelfCheckInCard from "./PerformerSelfCheckInCard";
import {SESSION_TYPE} from "../../domain/SessionType";
import {useSessionPolling} from "../../hooks/useSessionPolling";

const TIMESLOT_DETAILS_CARD_COLOR = yellow[50];
const TIMESLOT_CONTAINER_COLOR = blueGrey[50];

const styles = {
    container: {
        timeslotDetail: (gridView) => ({
            backgroundColor: TIMESLOT_CONTAINER_COLOR,
            alignSelf: 'flex-start',
            padding: '1rem',
            height: gridView ? 'auto' : 'calc(100vh - 7.5rem)',
            position: 'relative',
            minHeight: '100%'
        })
    },
    card: {
        timeslotDetails: {
            backgroundColor: TIMESLOT_DETAILS_CARD_COLOR
        }
    },
    session: {
        upcoming: {
            display: "flex",
            flexDirection: "column",
            gap: "1rem"
        },
        upcomingShift: {
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            marginBottom: "1rem"
        },
        noUpcoming: {
            paddingBottom: 0
        },
        selected: {
            marginTop: '1rem'
        }
    }
};

export default function TimeslotPanel({timeslotEvents, shiftEvents, timeslots, selectedTimeslot, selectedSessionServiceTypeDetails, handleCloseSelectedTimeslot, gridView= false, useSlidingTimeslotPanel = false, onPdfClick, onExpandContent}) {

    const {time, upcomingSessions} = useSessionPolling(timeslotEvents, timeslots);
    const upcomingShiftWhichRequiresCheckIn = buildMostUpcomingShiftWhichRequiresPerformerCheckIn(shiftEvents);

    const isSelectedSessionDisplayable = selectedTimeslot &&
        (
          selectedTimeslot.sessionType === SESSION_TYPE.TEACHING
          || selectedTimeslot.sessionType === SESSION_TYPE.BREAK
          ||selectedTimeslot.sessionType === SESSION_TYPE.TRAINING
        );

    return <Grid size={7} sx={styles.container.timeslotDetail(gridView)}>
        {
          upcomingShiftWhichRequiresCheckIn
          && <Box sx={styles.session.upcomingShift}>
              <Paper elevation={4}>
                  <PerformerSelfCheckInCard currentShift={upcomingShiftWhichRequiresCheckIn} />
              </Paper>
          </Box>
        }
        {
            useSlidingTimeslotPanel
              ?
              (
                <SlidingTimeslotPanel
                  timeslotEvents={timeslotEvents}
                  timeslots={timeslots}
                  selectedSession={isSelectedSessionDisplayable ? selectedTimeslot : null}
                  selectedSessionServiceTypeDetails={selectedSessionServiceTypeDetails}
                  onCardClose={handleCloseSelectedTimeslot}
                  onPdfClick={onPdfClick}
                  onExpandContent={onExpandContent}
                />
              )
              :
              (
                <>
                {upcomingSessions && upcomingSessions.length > 0 && (
                    <Box sx={styles.session.upcoming}>
                      {upcomingSessions.map((upcomingSession, index) => (
                        <Paper elevation={4} key={upcomingSession.id}>
                            <TimeslotDetailsCard
                                selectedEvent={upcomingSession}
                                serviceTypeDetails={{
                                    "type": upcomingSessions[index].type,
                                    color: upcomingSessions[index].color
                                }}
                                currentTime={time}
                                onPdfClick={onPdfClick}/>
                        </Paper>
                      ))}
                    </Box>
                )}
                {upcomingSessions && upcomingSessions.length === 0 && (
                    <TimeslotDetailsCard style={styles.session.noUpcoming} currentTime={time} onPdfClick={onPdfClick} onExpandContent={onExpandContent} />
                )}
                {isSelectedSessionDisplayable && (
                    <Paper elevation={12} style={styles.session.selected}>
                      <TimeslotDetailsCard
                          style={styles.card.timeslotDetails}
                          onCardClose={handleCloseSelectedTimeslot}
                          selectedEvent={selectedTimeslot}
                          serviceTypeDetails={selectedSessionServiceTypeDetails}
                          currentTime={time}
                          onPdfClick={onPdfClick}/>
                    </Paper>
                )}
              </>
          )
        }
    </Grid>;
}
